import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "arrow", "filters" ]

  resetFilters(event) {
    event.preventDefault();

    $("#query_date").val("any")
    $("#query_locale").val("any")
    $("#query_search").val("")
  }
}
